import React, { Component } from 'react';
import { connect } from 'react-redux';
import RTVDialog from '../commons/dialogs/RTVDialog';
import { showBlockedUserErrorAlert } from '../redux/actions/common';

class ErrorsAlertProvider extends Component {
  render() {
    const { children, openBlockedUserAlert, dispatch } = this.props;

    return (
      <>
        {children}
        <RTVDialog
          open={openBlockedUserAlert}
          onClose={() => dispatch(showBlockedUserErrorAlert(false))}
          title="UPS! no podes realizar esta acción."
          message="La vendedora bloqueó a tu usuario para que no puedas interactuar con sus productos."
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  openBlockedUserAlert: state.common.openBlockedUserAlert
});

export default connect(mapStateToProps)(ErrorsAlertProvider);
